import { render } from "./ModalEditarTarefaReuniao.vue?vue&type=template&id=2b595673"
import script from "./ModalEditarTarefaReuniao.vue?vue&type=script&lang=js"
export * from "./ModalEditarTarefaReuniao.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__